import { createAction, props } from '@ngrx/store'

const SOURCE = '[Common Domain Components]'

export const resetAttachmentTypeScanData = createAction(`${ SOURCE } resetAttachmentTypeScanData`)

export const setAttachmentTypeScanDataAttachment = createAction(
    `${ SOURCE } setAttachmentTypeScanDataAttachment`,
    props<{attachment: any; ownersLength: number}>())

export const setAttachmentTypeScanDataProperty = createAction(
    `${ SOURCE } setAttachmentTypeScanDataProperty`,
    props<{value: any; property: string}>())

export const setAttachmentTypeScanDataToggleCheckSubject = createAction(
    `${ SOURCE } setAttachmentTypeScanDataToggleCheckSubject`,
    props<{id: any; ownersLength: number}>())

export const setAttachmentTypeScanDataToggleCheckAll = createAction(
    `${ SOURCE } setAttachmentTypeScanDataToggleCheckAll`,
    props<{ownerIds: any[]}>())

// ----

export const noAction = createAction(`${ SOURCE } noAction`)